import React, { useCallback } from "react";
import { Create, Toolbar, useCreate, useRedirect, useNotify } from 'react-admin';
import Form from "./Form";

import "./styles/main.css"
import SaveButtonAware from "../component/SaveButtonAware";

const DivisionCreate = props => {
    const DivisionCreateToolbar = props => {
        const [create, { loading, error }] = useCreate('divisions');
        const redirectTo = useRedirect();
        const notify = useNotify();
        const { basePath } = props;
        const handleSave = useCallback(
            (values, redirect) => {
                create(
                    { payload: {data: {...values}} },
                    {
                        onSuccess: ({data: newRecord}) => {
                            notify('Аптечний заклад збережено', 'info');
                            redirectTo(redirect, basePath, newRecord.id, newRecord);
                        },
                        onError: (error) => {
                            alert('here1');
                        }
                    }
                );
            },
            [create, notify, redirectTo, basePath]
        );

        if (error) {
            notify('', 'error');
        }

        return <Toolbar {...props}>
            <SaveButtonAware {...props} submitOnEnter={false} onSave={handleSave} label={"Зберегти"} />
        </Toolbar>;
    };

    return (
        <Create {...props} title="Створення аптеки" undoable={false}>
            <Form toolbar={<DivisionCreateToolbar {...props} />} />
        </Create>
    );
};

export default DivisionCreate;
